import type { QueryKey } from "@msuite/ui/query";
import { DataTable, type Row } from "@msuite/ui/table";
import type { IncomingInvoiceDetail } from "@msuite/utils/types";
import type { ApprovalRow } from "./approval-row";
import { HandOverApprovalButton } from "./hand-over-approval-button";
import { columns } from "./table-config";
import { toApprovalRows } from "./to-approval-rows";

/** Props Interface */
interface IncomingInvoiceApprovalsTableProps {
	incomingInvoice: IncomingInvoiceDetail | undefined;
	isLoading: boolean;
	queryKey: QueryKey;
	refetch: () => Promise<void>;
}

/**
 * The approvals of an invoice in the order its chain decides them, with the review on the
 * caller's own row and every approver whose turn it is now highlighted. Reads everything off the
 * invoice detail, so any page that holds one can render it.
 */
export function IncomingInvoiceApprovalsTable({
	incomingInvoice,
	isLoading,
	queryKey,
	refetch,
}: IncomingInvoiceApprovalsTableProps) {
	/** Functions */
	function getRowStyles(row: Row<ApprovalRow>) {
		return row.original.turn === "now" ? { className: "table-row-highlighted" } : {};
	}

	/** Computed */
	const rows = toApprovalRows(incomingInvoice);

	/** Render */
	return (
		<DataTable
			data={rows}
			columns={columns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={<HandOverApprovalButton incomingInvoice={incomingInvoice} />}
			getRowStyles={getRowStyles}
			persistenceKey="incoming-invoice-approvals-table"
		/>
	);
}
